import type { InputHTMLAttributes, TextareaHTMLAttributes } from "react";
import { cn } from "@rosette/ts/src/util/cn.js";


/** Shared by TextInput and TextArea. Sizes are em, so a caller's text size scales the field. */
const FIELD_CLASSES = cn(
    "mt-1 mb-2 flex w-full rounded-lg bg-surface-sunken px-[0.75em]",
    "text-base text-strong",
    "focus-visible:border-transparent focus-visible:outline-2 focus-visible:outline-focus",
    "disabled:cursor-not-allowed disabled:opacity-50",
);


interface TextInputProps extends InputHTMLAttributes<HTMLInputElement> {
    type?: "text" | "email" | "password" | "number" | "search" | "url" | "tel";
}


/** A one-line field for typing text into a form, full width. */
export function TextInput({ type = "text", className, ...props }: TextInputProps) {
    return (
        <input
            type={type}
            {...props}
            className={cn(FIELD_CLASSES, "h-[2.2em] shadow-md", className ?? null)} />
    );
}


/** A field for typing several lines of text into a form, full width. */
export function TextArea({ className, ...props }: TextareaHTMLAttributes<HTMLTextAreaElement>) {
    return (
        <textarea
            {...props}
            className={cn(FIELD_CLASSES, "py-[1.1em]", className ?? null)} />
    );
}
